import { render } from "./EndedTournamentCard.vue?vue&type=template&id=46837abd&ts=true"
import script from "./EndedTournamentCard.vue?vue&type=script&lang=ts"
export * from "./EndedTournamentCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__